import { ChangeEventHandler } from 'react'
import { StyledAgreedForm } from './agreed-form.styles'
import { Checkbox, Error } from 'primsell-shared-layer/components'
import { ICheckboxProps } from 'primsell-shared-layer/types'

interface IAgreedFormProps extends ICheckboxProps {
  name?: string
  checked?: boolean
  className?: string
  onChange: ChangeEventHandler<HTMLInputElement>
  error?: string
  contentText: JSX.Element
}

const AgreedForm = ({ onChange, checked, className, error, contentText, ...props }: IAgreedFormProps): JSX.Element => {
  return (
    <StyledAgreedForm className={className}>
      <div>
        <Checkbox onChange={onChange} checked={checked} {...props} />
        {contentText}
      </div>
      {error && <Error error={error} />}
    </StyledAgreedForm>
  )
}

export { AgreedForm }
